export default __webpack_public_path__ + "static/mini-4-2f9c7517ab05479deaacd01014aa9d1b.png";